import AuthContentWrapper from "./components/AuthContentWrapper";
import { C2Text, C3Text, T1Text } from "../../common/components/text/CustomText";
import { Column, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import { useNavigate, useSearchParams } from "react-router-dom";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import AuthService from "../../service/AuthService";
import { useEffect, useState } from "react";
import CustomPopup from "../../common/components/popup/CustomPopup";
import { Theme } from "../../common/Theme";

function UnlockLoginMessagePage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const userId = searchParams.get("userId");
    const authKeyNum = searchParams.get("authKeyNum");
    const service = new AuthService();

    // api 에러 팝업
    const [isPopupOpened, setIsPopupOpened] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    useEffect(() => {
        if (authKeyNum) {
            service.unlockLogin({ userId, authKeyNum }).catch((error) => {
                setPopupMessage(error.message);
                setIsPopupOpened(true);
            });
        }
    }, [userId, authKeyNum, service]);

    const handleResendUnlockMail = async () => {};

    return (
        <AuthContentWrapper contentPadding={"62px 60px"}>
            <Column justifyContent={"center"}>
                <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                    Laundry Crew Admin
                </T1Text>
                <SizedBox height={"10px"} />
                <C2Text fontColor={Theme.color.gray500}>Laundry Crew account created</C2Text>
                <SizedBox height={"44px"} />
                <C2Text fontColor={Theme.color.gray500} textAlign={"center"}>
                    Please sign in from the service you initially signed up.
                </C2Text>
                <SizedBox height={"32px"} />
                <FullWidthButton onClick={() => navigate("/auth/login")} text={"Ok"} />
                <SizedBox height={"12px"} />
                <FullWidthButton
                    backgroundColor={Theme.color.white}
                    onClick={handleResendUnlockMail}
                    text={"Resend Email"}
                />
                <SizedBox height={"20px"} />
                <Row width={"100%"} justifyContent={"center"} alignItem={"center"}>
                    <C3Text fontColor={Theme.color.gray500}>Copyright © LG Electronics. All Rights Reserved.</C3Text>
                </Row>
            </Column>
            <CustomPopup isOpen={isPopupOpened} onConfirm={() => setIsPopupOpened(false)} message={popupMessage} />
        </AuthContentWrapper>
    );
}

export default UnlockLoginMessagePage;
